import { Button, type ButtonProps } from "react-aria-components";

type ActionButtonTone = "primary" | "secondary" | "ghost" | "danger";

type ActionButtonProps = ButtonProps & {
  tone?: ActionButtonTone;
};

export function ActionButton({ className, tone = "secondary", ...props }: ActionButtonProps) {
  const classes = ["action-button", `action-button-${tone}`, className]
    .filter(Boolean)
    .join(" ");

  return <Button {...props} className={classes} />;
}
